import { Component, ViewEncapsulation, OnInit, ChangeDetectorRef } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { DialogComponent } from "./views/commons/dialog/dialog.component";
import { GlobalFlagsService } from "./services/global-flags.service";
import { OAuthService } from "./services/oauth.service";
import { Idle, DEFAULT_INTERRUPTSOURCES, AutoResume } from "@ng-idle/core";
import { environment } from "../environments/environment";
import { TranslateService } from "@ngx-translate/core";

declare let ga: Function;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./styles/css/dashlite.css", "./styles/csc-theme.scss", "./styles/css/theme.css","./styles/css/libs/bootstrap-icons.css"],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
  idleState = "Not started.";
  timedOut = false;
  lastPing?: Date = null;
  showButton: boolean;
  detectBrowser: boolean;
  sessionExpired = false;
  isLogin :boolean;
  isForgotPassword :boolean;
  isMFA :boolean;
  isSSO :boolean;
  isDOBCheck :boolean;
  constructor(
    private router: Router,
    private globalFlagsService: GlobalFlagsService,
    private oAuthService: OAuthService,
    private dialog: MatDialog,
    private idle: Idle,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef
  ) {
    this.router.events.subscribe(() => window.scrollTo(0, 0));
    // sets an idle timeout of 5 seconds, for testing purposes.
    idle.setIdle(environment.idleTime.idle);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(environment.idleTime.timeout);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.setAutoResume(AutoResume.notIdle);

    let dialogTimeOut;
    idle.onIdleEnd.subscribe(() => {
      // No longer idle
      this.showButton = true;
    });
    idle.onTimeout.subscribe(() => {
      // Timed out
      this.timedOut = true;
      this.globalFlagsService.setUserLogged(false);
      this.dialog.closeAll();
      this.oAuthService.logout();
      this.sessionExpired = true;
      this.router.navigate(["/login"]);
    });
    idle.onIdleStart.subscribe(() => {
      // On idle
      const data = {
        message: "You will be logged out on: ",
        time: environment.idleTime.timeout,
      };
      dialogTimeOut = this.dialog.open(DialogComponent, {
        data,
        disableClose: true,
      });
      dialogTimeOut.afterClosed().subscribe((result) => {
        if (result === "stopIdle") {
          this.resetIdle();
        }
      });
    });

    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        this.isLogin = window.location.pathname.includes("/login");
        this.isForgotPassword =  window.location.pathname.includes("/forgotPassword");
        this.isMFA =  window.location.pathname.includes("/mfaLogin");
        this.isSSO =  window.location.pathname.includes("/continueWithSSO");
        this.isDOBCheck= ( window.location.href.includes("/startSurvey?token="));
      }
    });
  }

  showLoader = false;
  showHeader = null;
  canShowHeader = true;
  showBreadcrumb = null;

  ngOnInit() {
    this.isLogin = window.location.pathname.includes("/login");
    this.isForgotPassword = window.location.pathname.includes("/forgotPassword");
    this.isMFA = window.location.pathname.includes("/mfaLogin");
    this.isSSO = window.location.pathname.includes("/continueWithSSO");
    this.isDOBCheck= (window.location.href.includes("/startSurvey?token="));
    this.globalFlagsService.loading.subscribe((val: boolean) => {
      if (val != false) {
        this.showLoader = true;
      }
      else
        this.showLoader = false;
    });
    this.globalFlagsService.showHeader.subscribe((val: boolean) => {
      this.canShowHeader = val;
    });

    this.globalFlagsService.userLogged.subscribe((val: boolean) => {
      if (val) {
        this.resetIdle();
      } else {
        this.idle.stop();
      }
    });
    // If user is logged, we start the idle setting to true the user logged flag
    if (OAuthService.getAccessToken()) {
      this.globalFlagsService.setUserLogged(true);

      const langCode = JSON.parse(localStorage.getItem("langCode"));
      this.translate.use(langCode);
    }
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        ga("set", "page", event.urlAfterRedirects);
        ga("send", "pageview");
        this.modifyHeader(event);
      }
    });
    this.detectIE();
    this.cdRef.detectChanges();
  }

    ngAfterContentChecked() {
      this.cdRef.detectChanges();
      this.isLogin = this.router.url === '/login';
      this.isForgotPassword = this.router.url === '/forgotPassword';
      this.isMFA = this.router.url === '/mfaLogin';
      this.isSSO = this.router.url === '/continueWithSSO';
    }


  resetIdle() {
    this.idle.watch();
    this.idleState = "Started.";
    this.timedOut = false;
    this.sessionExpired = false;
  }

  // Dont show header on login pages
  modifyHeader(location: any) {
    const regex = new RegExp("^/login");
    this.showHeader = !regex.test(location.url);
  }

  isSessionExpired() {
    return this.sessionExpired;
  }

  detectIE() {
    let ua = window.navigator.userAgent;
    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // IE 12 / Spartan
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge (IE 12+)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    let msie = ua.indexOf("MSIE ");
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
    }
    // other browser
    this.detectBrowser = true;
    return false;
  }
}
